//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { IAliasedDateRange } from '@components/date-range-picker/dateRangePickerModels';
import Interval from '@models/Interval';

export interface IInstagramScheduleExportState {
  errors: {
    fetchFeedPreviewExportError?: string;
    fetchScheduleExportError?: string;
  };
  flags: {
    hasFetchedScheduleExport: boolean;
    isExportModalOpen: boolean;
    isFetchingFeedPreviewExport: boolean;
    isFetchingScheduleExport: boolean;
  };
  dateRange: IAliasedDateRange;
}

export const FILENAME_DATE_FORMAT = 'YYMMDD';

export const DATE_RANGE_INTERVAL_PARAM = 'dateRangeInterval';
export interface IScheduleExportQueryParams {
  [DATE_RANGE_INTERVAL_PARAM]?: Interval;
}
